var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { "justify-space-between": "", "align-baseline": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs7: "", md6: "", lg5: "", xl4: "" } },
            [
              _c(
                "v-layout",
                { attrs: { "justify-start": "", "align-end": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs5: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: _vm.$t("siteName"),
                          items: _vm.warehousesSites,
                          "item-text": "siteName",
                          "return-object": ""
                        },
                        model: {
                          value: _vm.selectedSite,
                          callback: function($$v) {
                            _vm.selectedSite = $$v
                          },
                          expression: "selectedSite"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs1: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs5: "" } },
                    [
                      _c("SelectWidget", {
                        attrs: {
                          label: _vm.$t("organizations"),
                          items: _vm.organizations,
                          chipText: "organizationId",
                          itemText: "displayName",
                          itemValue: "key"
                        },
                        model: {
                          value: _vm.selectedTenant,
                          callback: function($$v) {
                            _vm.selectedTenant = $$v
                          },
                          expression: "selectedTenant"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", disabled: _vm.loading },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.getWarehouseInventory.apply(null, arguments)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.handleExportWarehouseInventoryDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _vm.hasAuthToFunctionality("adjustInventory")
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.showAdjustInventoryDialog.apply(
                            null,
                            arguments
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("adjust")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showAdjustHistoryDialog.apply(null, arguments)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("changeLog")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs4: "", md2: "", xl1: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "filter_list",
                  label: _vm.$t("search"),
                  "single-line": "",
                  "hide-details": "",
                  clearable: ""
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.filterEnter.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        ref: "inventoryTable",
        staticClass: "elevation-2 myDense",
        attrs: {
          headers: _vm.headers,
          items: _vm.products,
          search: _vm.filter,
          loading: _vm.loading,
          pagination: _vm.pagination,
          "rows-per-page-items": _vm.rowPerPage
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "progress",
            fn: function() {
              return [
                _c("v-progress-linear", {
                  attrs: { color: "blue", indeterminate: "" }
                })
              ]
            },
            proxy: true
          },
          {
            key: "headerCell",
            fn: function(props) {
              return [
                _vm._v("\n      " + _vm._s(props.header.text) + "\n      "),
                props.header.value === "quantity"
                  ? [
                      _vm._v(
                        "\n        (" +
                          _vm._s(
                            _vm.filteredItems.reduce(function(acc, item) {
                              return item.quantity + acc
                            }, 0)
                          ) +
                          ")\n      "
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                props.header.value === "abnormalQty"
                  ? [
                      _vm._v(
                        "\n        (" +
                          _vm._s(
                            _vm.filteredItems.reduce(function(acc, item) {
                              return item.abnormalQty + acc
                            }, 0)
                          ) +
                          ")\n      "
                      )
                    ]
                  : _vm._e()
              ]
            }
          },
          {
            key: "items",
            fn: function(props) {
              return [
                _c("td", { staticClass: "subheading" }, [
                  _vm._v(_vm._s(props.index + 1))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.upc))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.productName))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _vm._l(props.item.distribution, function(item, index) {
                      return [
                        index <= _vm.expandTo[props.index]
                          ? _c(
                              "v-tooltip",
                              {
                                key: item[0],
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-chip",
                                            _vm._g(
                                              { attrs: { small: "" } },
                                              on
                                            ),
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.organizations.find(
                                                      function(org) {
                                                        return (
                                                          org.key === item[0]
                                                        )
                                                      }
                                                    ) || {})["organizationId"]
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _c("span", [
                                  item[1].quantity
                                    ? _c(
                                        "span",
                                        { staticStyle: { display: "block" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("normal")) +
                                              ": " +
                                              _vm._s(item[1].quantity) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item[1].abnormalQty
                                    ? _c(
                                        "span",
                                        { staticStyle: { display: "block" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("abnormal")) +
                                              ": " +
                                              _vm._s(item[1].abnormalQty)
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        index === _vm.expandTo[props.index] + 1
                          ? _c(
                              "span",
                              {
                                key: item[0],
                                staticClass: "grey--text caption",
                                on: {
                                  click: function($event) {
                                    return _vm.expandChips(props.index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("clickExpand", {
                                        num:
                                          props.item.distribution.length -
                                          1 -
                                          _vm.expandTo[props.index]
                                      })
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "text-xs-left",
                    staticStyle: {
                      "white-space": "pre-wrap",
                      "word-break": "break-word",
                      "max-width": "300px"
                    }
                  },
                  [_vm._v(_vm._s(props.item.location.join(", ")))]
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.quantity || ""))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.abnormalQty || ""))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(tooltip) {
                                return [
                                  _c(
                                    "div",
                                    _vm._g({}, tooltip.on),
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            dark: "",
                                            color: "primary",
                                            icon: "",
                                            flat: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.showEditLocationDialog(
                                                props.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("edit")])],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("editLocation")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("SimpleTextPopup", {
        attrs: {
          title: _vm.$t("reportMissingItems"),
          rightMethod: _vm.reportLost,
          rightButtonText: "Report",
          rightButtonDisabled: !_vm.valid,
          medium: ""
        },
        on: {
          popupClose: function($event) {
            _vm.reportMissingDialog = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-form",
                  {
                    ref: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid"
                    }
                  },
                  [
                    _c(
                      "v-layout",
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: _vm.$t("product"),
                            "prepend-icon": "shopping_cart",
                            readonly: ""
                          },
                          model: {
                            value: _vm.report.productName,
                            callback: function($$v) {
                              _vm.$set(_vm.report, "productName", $$v)
                            },
                            expression: "report.productName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c("v-text-field", {
                          staticClass: "required_field",
                          attrs: {
                            label: _vm.$t("quantity"),
                            "prepend-icon": "event",
                            rules: [
                              _vm.fieldIsRequired("quantity"),
                              _vm.fieldIsInteger("quantity"),
                              _vm.fieldIsNoLessThanZero("quantity")
                            ],
                            autofocus: ""
                          },
                          model: {
                            value: _vm.report.quantity,
                            callback: function($$v) {
                              _vm.$set(_vm.report, "quantity", _vm._n($$v))
                            },
                            expression: "report.quantity"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: _vm.$t("site"),
                            "prepend-icon": "local_shipping",
                            readonly: ""
                          },
                          model: {
                            value: _vm.report.warehouseSite,
                            callback: function($$v) {
                              _vm.$set(_vm.report, "warehouseSite", $$v)
                            },
                            expression: "report.warehouseSite"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.reportMissingDialog,
          callback: function($$v) {
            _vm.reportMissingDialog = $$v
          },
          expression: "reportMissingDialog"
        }
      }),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("editLocation"),
          rightMethod: _vm.editLocation,
          medium: ""
        },
        on: {
          popupClose: function() {
            _vm.editLocationDialog = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c("v-layout", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("siteName") +
                        ": " +
                        (_vm.selectedSite || {}).siteName
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-text-field", {
                          staticClass: "required_field",
                          attrs: { label: _vm.$t("upc"), readonly: "" },
                          model: {
                            value: _vm.upcInEdit.upc,
                            callback: function($$v) {
                              _vm.$set(_vm.upcInEdit, "upc", $$v)
                            },
                            expression: "upcInEdit.upc"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-layout", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("productName") + ": " + _vm.upcInEdit.productName
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-combobox", {
                          attrs: {
                            chips: "",
                            multiple: "",
                            "deletable-chips": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.upcInEdit.location,
                            callback: function($$v) {
                              _vm.$set(_vm.upcInEdit, "location", $$v)
                            },
                            expression: "upcInEdit.location"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.editLocationDialog,
          callback: function($$v) {
            _vm.editLocationDialog = $$v
          },
          expression: "editLocationDialog"
        }
      }),
      _vm._v(" "),
      _vm.adjustInventoryDialog
        ? _c("WarehouseAdjustInventory", {
            attrs: { actionAfterSubmit: _vm.getWarehouseInventory },
            model: {
              value: _vm.adjustInventoryDialog,
              callback: function($$v) {
                _vm.adjustInventoryDialog = $$v
              },
              expression: "adjustInventoryDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.adjustHistoryDialog
        ? _c("WarehouseAdjustLogs", {
            model: {
              value: _vm.adjustHistoryDialog,
              callback: function($$v) {
                _vm.adjustHistoryDialog = $$v
              },
              expression: "adjustHistoryDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("exportUpc"),
          rightMethod: _vm.submitBatchExportWarehouseInventory,
          rightButtonText: _vm.$t("export"),
          medium: ""
        },
        on: {
          popupClose: function($event) {
            return _vm.handleExportWarehouseInventoryDialog(false)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-select", {
                          attrs: {
                            label: _vm.$t("siteName"),
                            multiple: "",
                            items: _vm.warehousesSites,
                            "item-text": "siteName",
                            "return-object": ""
                          },
                          model: {
                            value: _vm.selectedSites,
                            callback: function($$v) {
                              _vm.selectedSites = $$v
                            },
                            expression: "selectedSites"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("SelectWidget", {
                          attrs: {
                            label: _vm.$t("organizations"),
                            items: _vm.organizations,
                            chipText: "organizationId",
                            itemText: "displayName",
                            itemValue: "key"
                          },
                          model: {
                            value: _vm.selectedTenants,
                            callback: function($$v) {
                              _vm.selectedTenants = $$v
                            },
                            expression: "selectedTenants"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.showExportWarehouseInventoryDialog,
          callback: function($$v) {
            _vm.showExportWarehouseInventoryDialog = $$v
          },
          expression: "showExportWarehouseInventoryDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46904f77", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46904f77","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InventoryWarehouse.vue
// module id = null
// module chunks = 